<template>
  <div class="productbundle-items-grid">
    <div class="sets-tiles">
      <div class="flex-grid" v-if="mounted">
        <ProductSetTile
          :key="`set-${set.id}`"
          v-for="set in sets"
          :set="set"
          :promotion="promotionName"
          :mobile-breakpoint="mobileBreakpoint"
          :large-images="largeImages"
        ></ProductSetTile>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSetTile from './ProductSetTile.vue';
import { onMounted, ref } from 'vue';

export default {
  name: 'ProductSetTiles',
  components: {
    ProductSetTile,
  },
  props: {
    sets: {
      type: Array,
      required: true,
    },
    mobileBreakpoint: {
      type: Number,
      default: 768,
    },
    largeImages: {
      type: Boolean,
      default: false,
    },
    promotionName: {
      type: String,
      default: null,
    },
  },
  setup() {
    const mounted = ref(false);

    onMounted(() => {
      mounted.value = true;
    });

    return {
      mounted,
    };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.productbundle-items-grid {
  padding-top: var(--space-6);
  padding-bottom: var(--space-6);

  .sets-tiles {
    width: 100%;

    .flex-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: var(--space-6);

      @media (min-width: $mobile-breakpoint) {
        grid-template-columns: 1fr 1fr;
      }
      @media (min-width: $extra-large-breakpoint) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
      @media (min-width: $desktop-breakpoint) {
        gap: var(--space-10);
      }

      .product-set-tile {
        width: 100%;
      }

      @media (max-width: calc($mobile-breakpoint - 1px)) {
        .product-set-tile {
          width: calc(100% + 40px);
          @mixin escapeResponsiveContainerPadding;
        }
      }
    }
  }

  .hide-loader {
    display: none;
  }
}
</style>
